// src/firebase/rtdb.js
import { db } from "./client";
import {
  ref,
  onValue,
  get,
  set,
  update,
  push,
  remove,
  runTransaction,
  serverTimestamp,
} from "firebase/database";

/** Subscribe list -> array [{_key, ...data}] */
export function subscribeList(path, cb) {
  const r = ref(db, path);
  return onValue(r, (snap) => {
    if (!snap.exists()) return cb([]);
    const obj = snap.val();
    const arr = Object.keys(obj).map((k) => ({ _key: k, ...obj[k] }));
    cb(arr);
  });
}

/** Read once */
export async function getOnce(path) {
  const snap = await get(ref(db, path));
  return snap.exists() ? snap.val() : null;
}

/** Set */
export async function setData(path, value) {
  await set(ref(db, path), value);
}

/** Update */
export async function updateData(path, value) {
  await update(ref(db, path), value);
}

/** Remove */
export async function removeData(path) {
  await remove(ref(db, path));
}

/** Push (returns key) */
export async function pushData(path, value) {
  const p = push(ref(db, path));
  await set(p, value);
  return p.key;
}

/** Multi-path atomic update (set null = delete) */
export async function updateMulti(map) {
  // map = { "path/a": value, "path/b": null }
  await update(ref(db), map);
}

/** Increment number by delta (transaction) */
export async function incNumber(path, delta) {
  const r = ref(db, path);
  await runTransaction(r, (curr) => {
    const n = Number(curr || 0);
    return n + Number(delta || 0);
  });
}

export { serverTimestamp };
